export default __webpack_public_path__ + "static/media/regalxReal01_downloadMT4.50df33d8.png";